import { Burger } from '../core'

$.fn.MainMenu_Item = function(menu) {
  let self = this.BlockElement()

  if (self.data('main-menu-item')) {
    return self.data('main-menu-item')
  }

  self.el = {
    link: self.find('.main-menu__link'),
    img: self.find('.menu-item-img').BlockElement()
  }

  self.clicked = function() {
    if ($('html').hasClass('--menu-transitioning')) {
      return false
    }
    $('.main-menu__item--active').removeClass('main-menu__item--active')
    $('.menu-item-img--active').removeClass('menu-item-img--active')
    self.addClass('main-menu__item--active')
    self.el.img.addModifier('active')
    $('html').addClass('--menu-transitioning')
    $('.page-transition').addClass('page-transition--force-visible')
    var extra_delay = $.mlmi.mobile.isMobile ? 1000 : 0
    setTimeout(function() {
      $('html').removeClass('--menu-open')
      menu.header.burger.maybe_close()
      setTimeout(function() {
        $('html').removeClass('--menu-transitioning')
        $('.page-transition').removeClass('page-transition--force-visible')
        $('.menu-item-img--visible').removeClass('menu-item-img--visible')
      }, 350)
    }, 1250 + extra_delay)
  }

  self.initialize_active = function() {
    self.addClass('main-menu__item--active')
    self.el.img.addModifier('active')
  }

  self.reset = function() {
    self.removeClass('main-menu__item--active')
    self.el.img.removeModifier('active')
  }

  self.initialize_item = function() {
    self.el.img.css('--menu-item-color', self.el.link.css('--menu-item-color'))
    menu.append(self.el.img)
    if (self.hasClass('main-menu__item--active')) {
      self.el.img.addModifier('active')
    }
    self.hover(function() {
      menu.sequence++
      if (menu.sequence == 1) {
        menu.addModifier('first-hover')
      } else if (menu.sequence > 1) {
        menu.removeModifier('first-hover')
      }
      self.el.img.addModifier('visible')
    }, function() {
      if (!$('html').hasClass('--menu-transitioning')) {
        self.el.img.removeModifier('visible')
      }
    })
  }

  return function() {
    self.initialize_item()
    self.el.link.on('click', self.clicked)
    self.data('main-menu-item', self)
    return self
  }()
}

$.fn.MainMenu = function(_header) {
  let self = $(this).BlockElement()

  if (self.data('main-menu')) {
    return self.data('main-menu')
  }

  self.el = {
    items: self.find('.main-menu__item')
  }
  self.header = _header
  self.items = []
  self.sequence = 0

  self.initialize_items = function() {
    self.el.items.each(function() {
      let item = $(this).MainMenu_Item(self)
      self.items.push(item)
    })
  }

  self.initialize_menu = function() {
    self.hover(function() {
      //
    }, function() {
      self.sequence = 0
      self.removeModifier('first-hover')
    })
  }

  self.reset_all = function() {
    self.el.items.each(function() {
      $(this).data('main-menu-item').reset()
    })
  }

  return function() {
    self.initialize_menu()
    self.initialize_items()
    self.data('main-menu', self)
    return self
  }()
}

export default {
  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.header__burger .burger', {
      onToggle: function() {
        $('.top-bar').css('--max-height', $('.top-bar .container').outerHeight() + 'px')
        if (obj.burger.isExpanded) {
          $('html').addClass('--menu-open')
        } else {
          $('html').removeClass('--menu-open')
        }
      },
    })

    /* Logo animation & loading */
    let logo_animation = bodymovin.loadAnimation({
      container: $('.header__brand').get(0),
      renderer: 'svg',
      autoplay: false,
      loop: false,
      path: '/assets/img/logo/LE_COMITE_LOGO.json',
    })

    logo_animation.addEventListener('complete', function(e, b) {
      if ($('html').hasClass('--loading')) {
        $('html').removeClass('--loading')
        $('.page-transition').addClass('page-transition--initial-hidden')
        setTimeout(function() {
          $('.page-transition').removeClass('page-transition--initial-hidden page-transition--visible')
        }, 600)
      }
    })
    logo_animation.addEventListener('data_ready', function() {
      logo_animation.goToAndPlay(1, true)
      $('.header__menu').css('--menu-height', $('.main-menu').outerHeight() + 'px')
      $('html').css('--header-height', $('.header').outerHeight(false) + 'px')
    })

    /* Menu items */
    let menu_items = ['projets', 'services', 'initiatives', 'cooperative', 'contact']
    jQuery.each(menu_items, function(index, menu_item) {
      window['menu_item_' + menu_item] = bodymovin.loadAnimation({
        container: $('.lotie_' + menu_item).get(0),
        renderer: 'svg',
        autoplay: true,
        loop: true,
        path: '/assets/img/menu/' + menu_item + '.json',
      })
    })

    /* Main menu */
    $('.header .main-menu').MainMenu(obj)

    /* Back to home */
    $('.header__brand').on('click', function() {
      $('.header .main-menu').data('main-menu').reset_all()
    })

    /* Header size on scroll */
    $.mlmi.scrollbar.addListener(function() {
      let top = $.mlmi.scrollbar.scrollTop
      if (top >= 50 && !$('html').hasClass('--header-minimized')) {
        $('html').addClass('--header-minimized')
      } else if (top < 50 && $('html').hasClass('--header-minimized')) {
        $('html').removeClass('--header-minimized')
      }
    })

    return obj
  }
}
